import React from 'react'

import { Box, Typography } from '../'

import { Color } from '@/utils'

const Label= ({
  label = '',
  isRequired = false,
  isDisabled = false,
}) => (
    <Box margin="0 0 5px">
        {/* Label */}
        <Typography
            variant="caption1"
            color={isDisabled ? Color.textDisabled : Color.textSecondary}
        >
            {`${label}`}
        </Typography>

        {/* Required asterisk */}
        {isRequired && (
            <Typography variant="caption1" color={Color.red}>
                {'\u00a0*'}
            </Typography>
        )}
    </Box>
)

export { Label }
